import React from "react";
import "./ThankYou.scss";
import BackGroundImg from "../../Home/BackGroundImg/BackGroundImg";
import { useNavigate } from "react-router-dom";
import { useMobile } from "../../../context/MobileContext";
import Navbar from "../../Navbar/Navbar";
import BurgerMenu from "../../BurgerMenu/BurgerMenu";
const ThankYou = () => {
  const navigate = useNavigate();
  const { isMobile } = useMobile();
  return (
    <>
      <BackGroundImg />
      {isMobile ? <Navbar /> : <BurgerMenu />}

      <section id="thank-you" className="full-page centered-container">
        <div className="card">
          <div className="col-start">
            <h1>Thank You for Registering!</h1>
            <p>Come back soon to play the adventures</p>
            <button onClick={() => navigate("/")}>Home</button>
            <button onClick={() => navigate("/adventure/demo")}>Demo</button>
          </div>
        </div>
      </section>
    </>
  );
};

export default ThankYou;
